export default __webpack_public_path__ + "static/media/missed-call.085ce243.svg";